module.exports = __webpack_public_path__ + "img/start.2dfe2c9e.png";